<span class="version"
    >{{ "version-login" | lang | lowercase }} {{ version }}</span
>
